/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* THE CODE BELOW IS FOR HE GCLA About PAGE HERO IMAGE TABS */

(function(){
  const hero = document.getElementById('gcla-hero-img');
  if(!hero) return;

  const IMG = {
    facility: 'https://cdn.shopify.com/s/files/1/0319/8592/6203/files/front_of_Grand_Cru_Liquid_Assets_facility.jpg?v=1760123082',
    tasting:  'https://cdn.shopify.com/s/files/1/0319/8592/6203/files/Grand_Cru_Liquid_Assets_Office.jpg',
    cellar:   'https://cdn.shopify.com/s/files/1/0319/8592/6203/files/secure_wine_cellar.jpg'
  };

  const tabs = Array.from(document.querySelectorAll('.gcla-phototab'));

  function setActive(key){
    const next = IMG[key];
    if (next && hero.src !== next) hero.src = next;
    tabs.forEach(btn =>
      btn.setAttribute('aria-selected', btn.dataset.img === key ? 'true' : 'false')
    );
  }

  // Hover + focus (desktop & keyboard)
  tabs.forEach(btn => {
    const key = btn.dataset.img;
    btn.addEventListener('mouseenter', () => setActive(key));
    btn.addEventListener('focus', () => setActive(key));
  });

  // Touch fallback: click to change
  const isCoarse = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
  if (isCoarse) {
    tabs.forEach(btn =>
      btn.addEventListener('click', () => setActive(btn.dataset.img))
    );
  }

  // Initialize based on aria-selected
  const initial = tabs.find(b => b.getAttribute('aria-selected') === 'true');
  setActive(initial ? initial.dataset.img : 'tasting');
})();
/* THE CODE ABOVE IS FOR HE GCLA About PAGE HERO IMAGE TABS */

/* Search UX: close search on outside click (including Searchanise results), and keep the dim overlay active while search is open. */
(function () {
  const SEARCH_ID = "Search";

  // Searchanise instant-search containers (treat clicks inside as "inside")
  const SNIZE_SELECTORS = [
    ".snize-ac-results",
    ".snize-ac-results-content",
    ".snize-ac-results-container",
    ".snize-results",
    ".snize-dropdown",
    "[id^='snize-']"
  ].join(",");

  function getSearchEl() {
    return document.getElementById(SEARCH_ID);
  }

  function isSearchOpen(searchEl) {
    return !!searchEl && searchEl.getAttribute("aria-hidden") === "false";
  }

  function getOverlayEl() {
    return document.querySelector(".PageOverlay");
  }

  function ensureOverlayVisible(visible) {
    const overlay = getOverlayEl();
    if (!overlay) return;
    overlay.classList.toggle("is-visible", !!visible);
  }

  function closeSearch(searchEl) {
    if (!searchEl) return;
    const closeBtn = searchEl.querySelector('[data-action="close-search"]');
    if (closeBtn) closeBtn.click();
  }

  // Close on outside click (use "click" to avoid racing Searchanise interactions)
  document.addEventListener(
    "click",
    function (e) {
      const searchEl = getSearchEl();
      if (!isSearchOpen(searchEl)) return;

      const clickedInsideSearch = e.target.closest("#" + SEARCH_ID);
      const clickedInsideSnize = e.target.closest(SNIZE_SELECTORS);

      // Allow clicking the header search icon/toggle without immediately closing
      const clickedSearchToggle = e.target.closest('[data-action="toggle-search"], [aria-controls="Search"]');

      if (clickedInsideSearch || clickedInsideSnize || clickedSearchToggle) return;

      closeSearch(searchEl);
    },
    false
  );

  // Keep overlay + body search-open state in sync whenever search is open
  function syncOverlay() {
    const searchEl = getSearchEl();
    const open = isSearchOpen(searchEl);

    // Enables your CSS rules (disables mega-menu hover/click while search is open)
    document.body.classList.toggle("search-open", open);

    // Keep the dim overlay visible while search is open
    ensureOverlayVisible(open);
  }

  const searchEl = getSearchEl();
  const overlayEl = getOverlayEl();

  if (window.MutationObserver) {
    // Watch the Search container (open/close state changes)
    if (searchEl) {
      const moSearch = new MutationObserver(syncOverlay);
      moSearch.observe(searchEl, {
        attributes: true,
        attributeFilter: ["aria-hidden", "class"]
      });
    }

    // Watch the overlay itself (Searchanise/theme may toggle it after typing)
    if (overlayEl) {
      const moOverlay = new MutationObserver(syncOverlay);
      moOverlay.observe(overlayEl, {
        attributes: true,
        attributeFilter: ["class", "style"]
      });
    }
  }

  // Initial sync
  syncOverlay();
  window.addEventListener("load", syncOverlay);
})();

